import { useState, useEffect } from "react";
import AnnouncementsBanner from "./AnnouncementsBanner";
const GetAnnouncementsData=()=> {
    const [announcements, setAnnouncements] = useState([]);
    useEffect(() => {
        fetch('/announcements.json', {
        })
            .then((res) => {
                return res.json()
            })
            .then((data) => {
                const sortedAnnouncementsByDate = data.announcements.sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());
                setAnnouncements(sortedAnnouncementsByDate);
            });
    }, []);
    return <AnnouncementsBanner announcements={announcements} />

};

export default GetAnnouncementsData;